export default "__VITE_ASSET__CPMUHZAB__"